<div class="min-h-screen flex flex-col bg-body">
  @if(!isVisible()) {
  <app-header />
  } @else {
  <app-header-mobile (isSidebarOpen)="sidebarOpen($event)"/>
  }
  <main class="view-height" id="main-content" [ngClass]="isMobileSidebarOpen() ? 'hidden' : ''">
      <router-outlet />
  </main>
  @if(!isVisible()) {
  <app-footer />
  } @else if(isVisible() && !isMobileSidebarOpen()) {
    <app-footer-mobile />
  }
  <app-modal-confirm [modal]="modalConfirm()" />
  @if (alert()?.open) {
  <app-alert [variant]="alert()?.variant">
    {{ alert()?.message }}
  </app-alert>
}
  @if(spinner()) {
      <div class="container-app fixed h-full w-full flex justify-center align-middle z-50 top-0 bg-body">
        <span class="loading loading-spinner loading-xl text-[#A100FF]"></span>
      </div>
  }
</div>
